import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'components/toggle';
import classNames from 'classnames';

import { Form } from 'react-bootstrap-5';
import { includes } from 'lodash';

export default class FilterCheckboxGroup extends React.Component {
  static propTypes = {
    behaviorToggle: PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
      checked: PropTypes.bool,
      onChange: PropTypes.func,
    }),
    checkAllIfNone: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    defaultKey: PropTypes.string,
    inline: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        className: PropTypes.any,
        id: PropTypes.any,
        value: PropTypes.any,
        label: PropTypes.any,
      })
    ).isRequired,
    selected: PropTypes.any,
    singleSelection: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    className: 'p-3',
    defaultKey: '',
  };

  checkAll = () => {
    const { selected, checkAllIfNone } = this.props;
    return checkAllIfNone && Array.isArray(selected) && selected.length === 0;
  };

  handleChange = (e) => {
    if (!this.checkAll()) return this.props.onChange(e);

    e.target.checked = true;
    this.props.onChange(e);
  };

  render() {
    return (
      <div className={classNames(this.props.className, 'd-flex flex-column gap-1')}>
        {this.renderBehaviorToggle()}
        {this.renderOptions()}
        {this.props.children}
      </div>
    );
  }

  isChecked(value) {
    if (this.props.singleSelection) {
      return this.props.selected === value;
    } else {
      return includes(this.props.selected || [], value);
    }
  }

  renderOptions() {
    return this.props.options.map((option, i) => (
      <Form.Check
        aria-label={option.value}
        checked={this.checkAll() || this.isChecked(option.value)}
        className={option.className}
        id={`${option.value}_filter`}
        label={option.label}
        name={`${option.value}_check`}
        type={this.props.singleSelection ? 'radio' : 'checkbox'}
        value={option.value}
        onChange={this.handleChange}
      />
    ));
  }

  renderBehaviorToggle() {
    if (!this.props.behaviorToggle) return null;

    const { label, onChange, checked } = this.props.behaviorToggle;
    return (
      <div className="filter-checkbox behavior-toggle">
        <Toggle checked={checked} theme="buildout" onChange={onChange} />
        <span>{label}</span>
      </div>
    );
  }
}
